class scrollHelper {
	constructor() {
		this.bindScrollHandler();
		this.initProgress();
	}
	bindScrollHandler() {
		var scrollLinks = Array.from(document.querySelectorAll('[data-scroll-to]'));
		scrollLinks.forEach((link, i) => {
			$(link).on('click', function (e) {
				e.preventDefault();
				$('html, body').animate({
					scrollTop: $($(this).attr('href')).offset().top - 125
				}, 1000);
			});
		});
	}

	initProgress() {
		var current_progress = this.calculateCurrentProgress();
		$('.progress-bar').css('width', current_progress);
		var _this = this;
		$(window).on('scroll', function () {
			var current_progress = _this.calculateCurrentProgress();
			$('.progress-bar').css('width', current_progress);
		});
	}

	calculateCurrentProgress() {
		var total_height = $(document).outerHeight();
		var current_position = $(window).scrollTop() + $(window).height();
		return (current_position * 100 / total_height) + '%';
	}
}
window.app.add('scroll', new scrollHelper());